// Referral code helpers (client-side).
// On LP/signup landing, capture ?ref=CODE into localStorage + cookie (7d).
// After signup completes, signup.tsx calls registerReferralAfterSignup().

const STORAGE_KEY = "pending_referral_code";
const COOKIE_KEY = "ref";
const COOKIE_TTL_SEC = 60 * 60 * 24 * 7;

export function getReferralCode(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const fromLocal = window.localStorage.getItem(STORAGE_KEY);
    if (fromLocal) return fromLocal;
  } catch {
    // ignore
  }
  try {
    const match = document.cookie.match(/(?:^|; )ref=([^;]+)/);
    if (match) return decodeURIComponent(match[1]);
  } catch {
    // ignore
  }
  return null;
}

export function captureReferralCodeFromUrl(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("ref")?.trim();
    if (!code) return null;
    setReferralCode(code);
    return code;
  } catch {
    return null;
  }
}

export function setReferralCode(code: string) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, code);
  } catch {
    // ignore
  }
  try {
    document.cookie = `${COOKIE_KEY}=${encodeURIComponent(code)}; Max-Age=${COOKIE_TTL_SEC}; Path=/; SameSite=Lax`;
  } catch {
    // ignore
  }
}

export function clearReferralCode() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  try {
    document.cookie = `${COOKIE_KEY}=; Max-Age=0; Path=/; SameSite=Lax`;
  } catch {
    // ignore
  }
}

const DEVICE_ID_KEY = "tv_device_id";

export function getOrCreateDeviceId(): string {
  if (typeof window === "undefined") return "";
  try {
    const existing = window.localStorage.getItem(DEVICE_ID_KEY);
    if (existing) return existing;
    const id = crypto.randomUUID();
    window.localStorage.setItem(DEVICE_ID_KEY, id);
    return id;
  } catch {
    return "";
  }
}
